import { z } from 'zod'

export const CountryCodeSchema = z
  .string()
  .length(2, 'Country code must be 2 characters')

export type User = {
  countryCode: string | null
}

// we use this fallback for searching when for what ever reason we don't have a country code
export const fallbackUserCountryCode = 'DE'
